import React from "react"
import styled from "styled-components"
import { media } from "utils/Media"
// import FooterNewsletter from "./FooterNewsletter"
import FooterSponsers from "./FooterSponsers"
import FooterBellyband from "./FooterBellyband"
import FooterMenus from "./FooterMenus"
import FooterText from "./FooterText"

const FooterBg = styled.div`
    background: ${props => props.theme.colors.primary};
    padding: 1rem 0;
    

    @media ${media.md} {
       padding: 2rem; 
    }

    @media ${media.lg} {
       padding: 4rem; 
    }
`

const Footer = ({footerBellyband}) => {
    return(
        <footer>
            {/* <FooterNewsletter /> */}
            <FooterSponsers />
            {footerBellyband && footerBellyband.length > 0 && (
                <FooterBellyband data={footerBellyband} />
            )}
            
            <FooterBg>
                <FooterMenus />
                <FooterText />
            </FooterBg>
        </footer>
    )
}

export default Footer